import { createContext, ReactNode, useState } from "react";
import { Mission2 } from "../Types";
import { ModalComponent } from "./ModalComponent";

interface MissionContextType {
    mission: Mission2;
}

export const MissionContext = createContext<MissionContextType>({
    mission: {} as Mission2,
});

interface UiComponentContextType {
    uiComponent: ReactNode | null;
    setUiComponent: (newUiComponent: ReactNode | null) => void;
}

export const UiComponentContext = createContext<UiComponentContextType>({
    uiComponent: null,
    setUiComponent: () => { }
});

export const MissionWorkflowComponent = (props: { states: ReactNode[], mission: Mission2 }) => {
    const [uiComponent, setUiComponent] = useState<ReactNode | null>(null);

    return (
        <MissionContext.Provider value={{ mission: props.mission }}>
            <UiComponentContext.Provider value={{ uiComponent, setUiComponent }}>
                {props.states.map(e => e)}
                <ModalComponent />
            </UiComponentContext.Provider>
        </MissionContext.Provider>
    );
}